import Breadcrumb from "@/components/base/Breadcrumb";
import { usePageMeta } from "@/hooks/usePageMeta";
import BrandStory from "./components/BrandStory";
import ReputationSection from "./components/ReputationSection";
import ContactSection from "./components/ContactSection";

const SITE_BASE = "https://kisscorner.github.io";

export default function AboutPage() {
  usePageMeta({
    title: "关于89890漫画网 - 品牌介绍与联系我们",
    description:
      "了解89890漫画网品牌故事、六年运营口碑与联系方式。我们是专注浪漫恋爱漫画的免费在线阅读平台，随时欢迎您的留言与建议。",
    keywords: "89890漫画网,关于我们,漫画阅读平台,联系我们,免费漫画",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "AboutPage",
        name: "关于89890漫画网",
        url: `${SITE_BASE}/about`,
        description:
          "89890漫画网是一家专注于浪漫恋爱漫画的免费在线阅读平台，提供高清连载与完结大结局畅读服务。",
        isPartOf: { "@id": `${SITE_BASE}/#website` },
        inLanguage: "zh-CN",
        mainEntity: { "@id": `${SITE_BASE}/#organization` },
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: `${SITE_BASE}/` },
          { "@type": "ListItem", position: 2, name: "关于我们", item: `${SITE_BASE}/about` },
        ],
      },
    ],
  });

  return (
    <div className="pt-16">
      <Breadcrumb items={[{ label: "关于我们" }]} />

      <section className="container-site">
        <div className="rounded-lg bg-secondary-100/70 px-6 py-10 text-center md:py-14">
          <span className="chip-tag !bg-primary-500 !text-background-50">
            <i className="ri-flag-2-fill text-xs" aria-hidden="true" />
            阅读，让生活更甜蜜
          </span>
          <h1 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            关于89890漫画网
          </h1>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-700 md:text-base">
            六年坚持免费阅读的漫画平台，为千万读者带来《青梅竹马不断向我甜蜜求婚》等优秀作品的完整结局畅读体验。
          </p>
        </div>
      </section>

      <BrandStory />
      <ReputationSection />
      <ContactSection />
    </div>
  );
}